import { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import AuthContext from '../store/auth-context';
import { AccessibilityContext } from '../store/accesibility-context';
import { Icon } from '@mui/material';
import LogoBlue from '../assets/logo_blue.svg?react';
import './MainNavigation.scss';

const LoggedInMenuList = ({ items }) => {
	const accessibilityCtx = useContext(AccessibilityContext);
	return (
		<>
			{items.map((item) => (
				<li
					key={item.id}
					className={`${
						accessibilityCtx.font_Size
							? 'navigation-items-font'
							: accessibilityCtx.contrast
							? 'navigation-items-contrast'
							: 'navigation-item'
					}`}
				>
					<NavLink
						to={item.to}
						className={({ isActive }) =>
							isActive ? 'active' : undefined
						}
					>
						<Icon>{item.icon}</Icon>
						<span className='item-label'>{item.label}</span>
					</NavLink>
				</li>
			))}
		</>
	);
};

function MainNavigation() {
	const navigate = useNavigate();
	const authCtx = useContext(AuthContext);
	const isLoggedIn = authCtx.isLoggedIn;
	const roleUser = authCtx.userData.role;

	if (!isLoggedIn) {
		return <></>;
	}
	// TODO get menu from backend
	const menuItemsList = [
		{
			id: 1,
			label: 'Dashboard',
			icon: 'grid_view',
			to: '/dashboard'
		},
		{
			id: 2,
			label: 'Archive',
			icon: 'layers',
			to: '/trials-archive'
		},
		{
			id: 3,
			label: 'FAQ',
			icon: 'contact_support',
			to: '/faqs'
		},
		{
			id: 4,
			label: 'Contact Us',
			icon: 'call',
			to: '/contact-us'
		}
	];
	const menuItemsSuperAdminList = [
		{
			id: 1,
			label: 'Dashboard',
			icon: 'grid_view',
			to: '/dashboard-admin'
		},
		{
			id: 2,
			label: 'Hospitals',
			icon: 'business',
			to: '/hospitals'
		},
		{
			id: 3,
			label: 'Contact Us',
			icon: 'call',
			to: '/contact-us'
		}
	];

	const menuItemsHospitalView = [
		{
			id: 1,
			label: 'Dashboard',
			icon: 'grid_view',
			to: '/hospital-admin'
		},
		{
			id: 2,
			label: 'Reports',
			icon: 'data_saver_off',
			to: '/reports-page'
		},
		{
			id: 3,
			label: 'Users',
			icon: 'person',
			to: '/dashboard-users'
		},
		{
			id: 4,
			label: 'Archive',
			icon: 'layers',
			to: '/trials-archive'
		},
		{
			id: 5,
			label: 'Contact Us',
			icon: 'call',
			to: '/contact-us'
		}
	];
	const menuItemsSupport = [
		{
			id: 1,
			label: 'Chat',
			icon: 'chat-bubble',
			to: '/support-page'
		}
	];
	return (
		<aside className='side-menu-container'>
			{/* TODO create menu control and... geometric symbol? */}
			<div className='side-menu-logo'>
				<LogoBlue />
			</div>
			<nav className='navigation-items'>
				<ul className='nav-items-list'>
					{(roleUser === 'QA' || roleUser === 'PI') && (
						<LoggedInMenuList items={menuItemsList} />
					)}
					{roleUser === 'HOSPITAL' && (
						<LoggedInMenuList
							items={menuItemsHospitalView}
						/>
					)}
					{roleUser === 'SUPER' && (
						<LoggedInMenuList
							items={menuItemsSuperAdminList}
						/>
					)}
					{roleUser === 'SUPPORT' && (
						<LoggedInMenuList items={menuItemsSupport} />
					)}
				</ul>
			</nav>
		</aside>
	);
}

export default MainNavigation;
